export const buildPaginationMeta = (pagination = {}, fallbackLimit = 10) => ({
  currentPage: pagination.currentPage ?? 1,
  totalPages: Math.max(1, pagination.totalPages ?? pagination.pages ?? 1),
  total: pagination.total ?? pagination.totalItems ?? 0,
  limit: pagination.limit ?? fallbackLimit,
  hasNextPage: pagination.hasNextPage ?? false,
  hasPrevPage: pagination.hasPrevPage ?? false,
});

const unwrapPayload = (body) => {
  if (!body || typeof body !== "object") return body;
  if (Array.isArray(body)) return body;
  if (body.success && body.data != null) return body.data;
  return body;
};

export const extractListItems = (body, keys = []) => {
  if (Array.isArray(body)) return body;

  for (const key of keys) {
    if (Array.isArray(body?.[key])) return body[key];
    if (Array.isArray(body?.data?.[key])) return body.data[key];
  }

  if (Array.isArray(body?.data)) return body.data;

  const unwrapped = unwrapPayload(body);
  if (Array.isArray(unwrapped)) return unwrapped;

  for (const key of keys) {
    if (Array.isArray(unwrapped?.[key])) return unwrapped[key];
  }

  if (Array.isArray(unwrapped?.items)) return unwrapped.items;
  if (Array.isArray(unwrapped?.results)) return unwrapped.results;

  return [];
};

export const toListArray = (value, keys = []) => extractListItems(value, keys);

export const parsePaginatedResponse = (body, keys, fallbackLimit = 10) => {
  const items = extractListItems(body, keys);
  const pagination =
    body?.pagination ||
    body?.data?.pagination ||
    unwrapPayload(body)?.pagination ||
    {};

  return {
    items,
    pagination: buildPaginationMeta(pagination, fallbackLimit),
  };
};
